import type { Employee, EmployeeForApi, Location } from './addEmployeesModal.types';

const DEFAULT_EMPLOYEE_COUNT = 3;

export const emptyEmployeeFactory = (locationId: number): Employee => ({
  fullName: '',
  email: '',
  groups: locationId ? [{ id: locationId }] : [],
});

export const getDefaultEmployees = (locations: Location[]): Employee[] => {
  const locationId = locations.length ? locations[0].id : 0;
  return new Array(DEFAULT_EMPLOYEE_COUNT).fill(true).map(() => emptyEmployeeFactory(locationId));
};

export const prepareEmployeeForSave = (employee: Employee): EmployeeForApi => {
  const [name, ...last] = employee.fullName.trim().split(' ');
  return {
    name,
    lastname: last.join(' '),
    groups: employee.groups,
    email: employee.email.trim(),
  };
};
